import * as React from 'react'
import { Accordion, Button, Card, Form } from 'react-bootstrap'
import { Button as ButtonMui } from '@mui/material'

import config from '../../../../constants/config'
import Activity from './Activity'
import { JobMode, workerHasPermission } from '../Job'
import { copyObject, randomId } from '../../../../utils'
import NumberFormatValidate from '../../../../components/NumberFormatValidate'
import { currentUserIsManager, currentUserIsWorker, getCurrentUserId } from '../../../../utils/currentUser'
import { LocationT, JobT, ActivityT } from '../../../../types/Job'
import { ActivityObj } from '../InitObjectJob'
import { OptionsLocationType } from '../OptionsFieldsJob'
import GoogleMapAutoComplete from '../../../../components/MapBoxAutoComplete/GoogleMapAutoComplete'
import Asterisk from '../../../../components/Asterisk'



interface LocationProps {
  jobMode: JobMode
  index: number
  job: JobT
  key: number
  location: LocationT  // TODO: Convert `any` to actual type
  onChangeAccordion(index: number): void,
  propagateDate?(activityDate: string): any
  removeLocation(index: number): void
  updateLocation(index: number, locationItem: any): void
  disabled: boolean
  required?: boolean
  showDetails?: boolean
  validated?: boolean
}

const Location: React.FunctionComponent<LocationProps> = (props): JSX.Element => {

  const addActivity = (): void => {
    let locationClone: LocationT = copyObject(props.location)
    let cloneActivity = copyObject(ActivityObj)
    cloneActivity.id = randomId()
    locationClone.activities.push(cloneActivity)
    props.updateLocation(props.index, locationClone)
  }

  const onChangeValue = (key: string, val: any): void => {
    let locationClone: LocationT = copyObject(props.location)
    locationClone[key] = val
    props.updateLocation(props.index, locationClone)
  }

  const removeActivity = (_index: number): void => {
    let cloneAddress = Object.assign({}, props.location)
    const activities = copyObject(cloneAddress.activities)
    let filteredItems = activities.slice(0, _index).concat(activities.slice(_index + 1, activities.length))
    if (filteredItems.length <= 0) {
      filteredItems.push(ActivityObj)
    }
    cloneAddress.activities = copyObject(filteredItems)
    props.updateLocation(props.index, cloneAddress)
  }

  const renderActivities = (activities: Array<any>): Array<JSX.Element> => {
    return activities.map((activity: ActivityT, _index: number): any => {
      return (
        <Activity

          disabled={props.disabled}
          activity={activity}
          index={_index}
          indexLocation={props.index}
          key={_index}
          removeActivity={removeActivity}
          updateActivity={updateActivity}
          job={props.job}
          jobMode={props.jobMode} />
      )
    })
  }

  const updateActivity = (activityIndex: number, activity: ActivityT): void => {
    if (props.index == 0 && activityIndex == 0 && props.propagateDate) props.propagateDate(activity.activityDate)
    let locationClone: LocationT = copyObject(props.location)
    locationClone.activities[activityIndex] = activity
    props.updateLocation(props.index, locationClone)
  }


  // const onPressAddressCallback = React.useCallback((value) => {
  //  return onPressAddress(value)
  // }, [location]);

  const onPressAddress = (value) => {
    let locationClone: LocationT = copyObject(props.location)
    locationClone.address = value.verbose_address
    locationClone.addressCountry = value.addressCountry
    locationClone.addressState = value.addressState
    locationClone.latitude = value.latitude
    locationClone.longitude = value.longitude
    props.updateLocation(props.index, locationClone)
  }

  /**
   *
   */
  const uniqueId = React.useMemo(() => {
    return randomId();
  }, [props.location])



  return (
    <Card>
      <Card.Header>
        <Accordion.Header as={Button} variant="link" eventKey={`${props.index}`} onClick={(e) => {
          props.onChangeAccordion(props.index)
        }}>
          Location {`${props.index + 1}`}
          {props.location.address != '' &&
            ' - ' + props.location.address}
        </Accordion.Header>
        {/* {!props.disabled && <span style={{ position: "absolute", right: 5 }}>
          <i className="fa fa-close"
            style={{ color: "red", cursor: "pointer" }}
            onClick={(): void => props.removeLocation(props.index)} />
        </span>} */}
      </Card.Header>
      <Accordion.Collapse eventKey={`${props.index}`}>
        <Card.Body>
          <Form>
            <Form.Group>
              <div style={{ display: 'grid', gridTemplateColumns: '4fr 1fr' }}>
                <div>
                  <Form.Label>Address {props.required && <Asterisk />}</Form.Label>

                  <GoogleMapAutoComplete
                    idAddresss={`addressLoction-${uniqueId}`}
                    disabled={props.disabled}
                    className='input-material'
                    apiKey={config.keyMap}
                    onChangeText={text => { }}
                    onPress={onPressAddress}
                    placeholder=''
                    textValue={`${props.location.address}`}
                  />


                </div>
                <div>
                  <Form.Label>Unit</Form.Label>
                  <Form.Control
                    disabled={props?.disabled}
                    className='input-material'
                    value={`${props.location.address2 ? props.location.address2 : ''}`}
                    onChange={(event: any) => { onChangeValue('address2', event.target.value) }} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: props?.showDetails ? '1fr 1fr 1fr' : '1fr' }}>
                <div>
                  <Form.Label>Location Type {props.required && <Asterisk />}</Form.Label>
                  <Form.Control as='select'
                    disabled={props?.disabled}
                    className='input-material'
                    value={`${props.location.locationType ? props.location.locationType : ''}`}
                    onChange={(event: any) => { onChangeValue('locationType', event.target.value) }}>
                    <option></option>
                    {Object.keys(OptionsLocationType).map((key, index) => {
                      return (
                        <option key={index} value={key} >{OptionsLocationType[key]}</option>
                      )
                    })}


                  </Form.Control>
                </div>

                {props?.showDetails &&
                  <div>
                    <Form.Label>Area, Sq. Ft.</Form.Label>
                    <NumberFormatValidate
                      onlyNumeric
                      disabled={props.disabled}
                      customInput={Form.Control}
                      className="input-material"
                      type="text"
                      defaultValue={`${props.location.numStairFlights}`}
                      value={`${props.location.numStairFlights}`}
                      onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != props.location.numStairFlights) {
                          onChangeValue('numStairFlights', floatValue)
                        }

                      }}

                      mask="_" />
                  </div>}
                {props?.showDetails && <div>
                  <Form.Label>Num. Rooms</Form.Label>
                  <NumberFormatValidate
                    onlyNumeric
                    disabled={props.disabled}
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${props.location.numRooms}`}
                    value={`${props.location.numRooms}`}
                    onValueChange={(values) => {
                      const { formattedValue, value, floatValue } = values;
                      if (floatValue != props.location.numRooms) {
                        onChangeValue('numRooms', floatValue)
                      }
                    }}
                    mask="_" />

                </div>}

              </div>

              {props?.showDetails && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr' }}>
                <span>
                  <Form.Label>Stairs, flights</Form.Label>
                  <NumberFormatValidate
                    onlyNumeric
                    disabled={props.disabled}
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${props.location.stairsflights}`}
                    value={`${props.location.stairsflights}`}
                    onValueChange={(values) => {
                      const { formattedValue, value, floatValue } = values;
                      if (floatValue != props.location.stairsflights) {
                        onChangeValue('stairsflights', floatValue)
                      }
                    }}
                    mask="_" />

                </span>
                <span>
                  <Form.Label>Elevator?</Form.Label>
                  <Form.Control as='select'
                    disabled={props.disabled}
                    className='input-material'
                    value={`${props.location.elevator ? props.location.elevator : ''}`}
                    onChange={(event: any) => { onChangeValue('elevator', event.target.value) }}>
                    <option></option>
                    <option value='false' >No</option>
                    <option value='true' >Yes</option>
                  </Form.Control>
                </span>
                <span>
                  <Form.Label>Long Carry, Ft.</Form.Label>
                  <NumberFormatValidate
                    onlyNumeric
                    disabled={props.disabled}
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${props.location.longCarry}`}
                    value={`${props.location.longCarry}`}
                    onValueChange={(values) => {
                      const { formattedValue, value, floatValue } = values;
                      if (floatValue != props.location.longCarry) {
                        onChangeValue('longCarry', floatValue)
                      }
                    }}
                    mask="_" />

                </span>
              </div>}

              {props?.showDetails && renderActivities(props.location.activities ? props.location.activities : [])}

              {(!props.disabled && props?.showDetails) &&
                <Form.Text className="text-muted">
                  <Button
                    variant='light'
                    onClick={(): void => { addActivity() }}>
                    Add Activity
                  </Button>
                </Form.Text>}
            </Form.Group>
            {(!props.disabled) &&
              <ButtonMui
                variant='outlined'
                color="error"
                fullWidth
                onClick={(): void => { props.removeLocation(props.index) }}>
                Remove Location
              </ButtonMui>
            }
          </Form>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  )
}

export default Location
